import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=3daaf61b&scoped=true&"
import script from "./UserAvatar.vue?vue&type=script&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=3daaf61b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daaf61b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3daaf61b')) {
      api.createRecord('3daaf61b', component.options)
    } else {
      api.reload('3daaf61b', component.options)
    }
    module.hot.accept("./UserAvatar.vue?vue&type=template&id=3daaf61b&scoped=true&", function () {
      api.rerender('3daaf61b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/UserAvatar.vue"
export default component.exports